﻿import $ from "jquery";

const validators = {
    date: {
        isValid: function (value, _element, _params) {
            var parts = value.split('-');
            return isValidDate(parts[0], parts[1], parts[2]);
        },
        unpack: function (options) {
            options.rules['date'] = options.params;
            options.messages['date'] = options.message;
        }
    },
    "date-minyears": {
        isValid: function (value, element, _params) {
            var minYearsAgo = parseInt($(element).attr("data-val-date-minyearsago"), 10);
            var date = parseDate(value);
            return getYears(date) >= minYearsAgo;
        },
        unpack: function (options) {
            var maxYearsAgo = parseInt($(options.element).attr("data-val-date-maxyearsago"), 10);
            options.rules["date-maxyears"] = maxYearsAgo;
            options.messages["date-minyears"] = options.message;
        }
    },
    "date-maxyears": {
        isValid: function (value, element, _params) {
            var maxYearsAgo = parseInt($(element).attr("data-val-date-maxyearsago"), 10);
            var date = parseDate(value);
            return getYears(date) <= maxYearsAgo;
        },
        unpack: function (options) {
            var minYearsAgo = parseInt($(options.element).attr("data-val-date-minyearsago"), 10);
            options.rules["date-minyears"] = minYearsAgo;
            options.messages["date-maxyears"] = options.message;
        }
    }
}

function setupDateInput() {
    $('input[data-dateboxfor]').on('change', function () {
        updateHiddenDate($(this).attr('data-dateboxfor'));
    });

    $('input[data-dateboxfor]').each(function () {
        var dateName = $(this).attr('data-dateboxfor');
        var day = $(`input[name="${dateName}.Day"]`).val();
        var month = $(`input[name="${dateName}.Month"]`).val();
        var year = $(`input[name="${dateName}.Year"]`).val();
        motivUi.globals.dateName = {
            fullDateEntered: (day && month && year)
        }
    });
};

function updateHiddenDate(dateName) {
    var day = $(`input[name="${dateName}.Day"]`).val();
    var month = $(`input[name="${dateName}.Month"]`).val();
    var year = $(`input[name="${dateName}.Year"]`).val();
    var dateInput = $(`input[name="${dateName}"]`);

    dateInput.val(`${year}-${month}-${day}`);
    if (motivUi.globals.dateName.fullDateEntered || (day && month && year)) {
        motivUi.globals.dateName.fullDateEntered = true;
        $("form").validate().element(`input[name="${dateName}"]`);
    }
}

function isValidDate(year, month, day) {
    year = parseInt(year, 10);
    var d = new Date(year, month - 1, day);
    var isDate = (d instanceof Date && !isNaN(d));
    return isDate && d.getDate() == day && d.getMonth() == month - 1 && d.getFullYear() == year;
}

function parseDate(dateString) {
    var parts = dateString.split('-');
    return new Date(parts[0], parts[1] - 1, parts[2]);
}

function getYears(date) {
    var today = new Date();
    var years = today.getFullYear() - date.getFullYear();
    var m = today.getMonth() - date.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < date.getDate())) {
        years--;
    }
    return years;
}

export { validators, setupDateInput }